import styled from 'styled-components'

export const TasksTableEntryContainer = styled.div`
  padding: 0px 10px;
`
